import { ColorEnum } from '@/constants/color'
import OrderFinalization from '@/features/pos/components/OrderFinalization'
import OrderFinalizationOverlay from '@/features/pos/components/OrderFinalization/Overlay'
import OverlayProvider from '@/features/pos/components/OrderFinalization/contexts/OverlayProvider'
import DismissOverlayProvider from '@/features/ui/components/Dropdown/contexts/DismissOverlay'
import { useScreenLayout } from '@/hooks/screen'
import { Tabs } from 'expo-router'
import { FC, Fragment } from 'react'
import { View } from 'react-native'

const Layout: FC = () => {
    const layout = useScreenLayout()

    const isCompact = layout === 'compact'

    const DismissOverlayWrapper = isCompact ? DismissOverlayProvider : Fragment
    const OrderFinalizationBottomSheetWrapper = OrderFinalization.BottomSheetPortal

    return (
        <OverlayProvider>
            <DismissOverlayWrapper>
                <View collapsable={!isCompact} style={{ flex: 1 }}>
                    <OrderFinalizationBottomSheetWrapper>
                        <Tabs
                            tabBar={() => null}
                            screenOptions={{ headerShown: false, animation: 'shift' }}
                        >
                            <Tabs.Screen
                                name="1-product-catalog"
                                options={{
                                    sceneStyle: {
                                        backgroundColor: ColorEnum.WHITE,
                                        paddingTop: 8,
                                    },
                                }}
                            />
                            <Tabs.Screen
                                name="2-order-finalization"
                                options={{ lazy: !isCompact }}
                            />
                        </Tabs>
                    </OrderFinalizationBottomSheetWrapper>
                    <OrderFinalizationOverlay />
                </View>
            </DismissOverlayWrapper>
        </OverlayProvider>
    )
}

export default Layout
